import { useAppSelector } from '@/store';

import { brandSettledOf } from './brand-settled';

/** {@link brandSettledOf} for the brand list in the store. */
export const useBrandSettled = (): boolean => {
  const hasBrand = useAppSelector((state) => state.casinoInstance.displayBrand !== undefined);
  const loaded = useAppSelector((state) => state.casinoInstance.loaded);
  const failed = useAppSelector((state) => Boolean(state.casinoInstance.error));
  const count = useAppSelector((state) => state.casinoInstance.brands?.length ?? 0);
  return brandSettledOf({ hasBrand, loaded, failed, count });
};
